import { FC } from "react";
import { Navigate } from "react-router-dom";
import { authClient } from "../../lib/auth-client";
import { toast } from "react-toastify";

export type ProtectedRouteProps = {
    permissions: Record<string, string[]>;
    component: FC;
};

const ProtectedRoute: FC<ProtectedRouteProps> = ({ component: Component, permissions }) => {
    const { data: session, isPending } = authClient.useSession();
    const user = session?.user as any;

    if (isPending) {
        return null;
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    const hasPermission = authClient.admin.checkRolePermission({
        permissions,
        role: user.role,
    });

    if (!hasPermission) {
        toast.error("You are not authorized to view this page.");
        return <Navigate to="/devices" replace />;
    }

    return <Component />;
};

export default ProtectedRoute;
